import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

const CheckInStat = ({ showBorder, number, label }) => {
   return (
      <div className={classNames('text-emerald-100 py-4', showBorder && 'border-b border-solid border-emerald-100/20')}>
         <div className="text-3xl font-medium">{number}</div>
         <div className="text-xs opacity-70">{label}</div>
      </div>
   )
}

CheckInStat.propTypes = {
   label: PropTypes.string.isRequired,
   number: PropTypes.string.isRequired,
   showBorder: PropTypes.bool
}

CheckInStat.defaultProps = {
   showBorder: true
}

const CheckinFeature = ({ active }) => {
   const [visible, setVisible] = useState(false)

   useEffect(() => {
      if (active) {
         setTimeout(() => {
            setVisible(true)
         }, 200)
      } else {
         setVisible(false)
      }
   }, [active])

   return (
      <div className="w-full h-full">
         <div
            className={classNames(
               'absolute top-[12%] left-[18%] w-[140%] rounded-3xl overflow-hidden shadow-[0px_10px_30px_rgba(0,0,0,0.3)] transition-all duration-700',
               visible ? 'translate-x-0 opacity-80' : 'translate-x-4 opacity-0'
            )}>
            <img
               className="w-full"
               src="/assets/custom/communities/images/features/checkin/2.png"
               alt="Check In Desk"
            />
         </div>

         <div
            className={classNames(
               'absolute top-[15%] left-[58%] w-[120%] h-[900px] bg-white rounded-xl overflow-hidden shadow-[0px_10px_30px_rgba(0,0,0,0.2)] transition-all duration-700 delay-50',
               visible ? 'translate-x-0 opacity-100' : 'translate-x-6 opacity-0'
            )}>
            <img
               className="w-full"
               src="/assets/custom/communities/images/features/checkin/1.png"
               alt="Check In Desk"
            />
         </div>

         <div
            className={classNames(
               'absolute -bottom-[25%] sm:-bottom-[5%] -left-[5%] sm:left-[9%] w-[70%] sm:w-[55%] rounded-t-3xl overflow-hidden shadow-[0px_10px_30px_rgba(0,0,0,0.3)] border border-solid border-emerald-100/10 bg-emerald-900/95 backdrop-blur-sm transition-all duration-700 delay-100 scale-[60%] sm:scale-100',
               visible ? 'translate-x-0 opacity-100' : 'translate-x-4 opacity-0'
            )}>
            <div className="w-full h-[300px] flex flex-col px-4">
               <CheckInStat number="962" label="Registered" />
               <CheckInStat number="590" label="Checked In" />
               <CheckInStat number="372" label="Not Checked In" showBorder={false} />
            </div>
         </div>
      </div>
   )
}

CheckinFeature.propTypes = {
   active: PropTypes.bool.isRequired
}

export default CheckinFeature
